import sty from './h.module.scss';

//wpUser
import {wpUser} from '../../../k';

export default function Header3({ href, title, onClick }) {
  return (
    <div className={sty.he}>
      <img
         src={`${window.localStorage.getItem('navbar')}`}
        //src={`${wpUser}/b/logo.svg`}
        onClick={() => {
          //window.location.href = {`${wpUser}/auth/`}; 
          window.location.href = `//${window.location.hostname}`;
        }}
      />
      <a href={href} ><span onClick={onClick}>
        {title}</span>
      </a>
    </div>
  ); 
}
